import React from 'react';
import { FormattedMessage } from 'react-intl';

import { IdelinkModuleTheme } from '../../configs/IdeLinkTheme';
import { NavbarModuleItem } from '../../../libs/IdeLink.Web.Common/src/components/NavBar/components/NavBarItem/NavBarItem';
import { RouteItem } from '../../../libs/IdeLink.Web.Common/src/types/RouteItem';
import { PrivateRoute } from '../../routes/PrivateRoute';
import { PermissionsActions } from '../../services/permissions/PermissionsActions';
import { AreaCreatePageLoading } from './Pages/AreaCreatePage/AreaCreatePageLoading';
import { AreaDetailsPageLoading } from './Pages/AreaDetailsPage/AreaDetailsPageLoading';
import { AreaListPageLoading } from './Pages/AreaListPage/AreaListPageLoading';
import { AreasPermissions } from './Services/AreasPermissions';

export class AreasModule {
    public static AREA_LIST: string = '/areas';
    public static AREA_CREATE: string = '/areas/create';
    public static AREA_DETAILS: string = '/areas/:id';

    private static getAreaListRoute = (): RouteItem => ({
        render: PrivateRoute,
        props: {
            path: AreasModule.AREA_LIST,
            component: AreaListPageLoading,
            hasAccess: () => AreasPermissions.Admin.canList,
        },
    });
    private static getAreaCreateRoute = (): RouteItem => ({
        render: PrivateRoute,
        props: {
            path: AreasModule.AREA_CREATE,
            component: AreaCreatePageLoading,
            hasAccess: () => AreasPermissions.Admin.canCreate,
        },
    });
    private static getAreaDetailsRoute = (): RouteItem => ({
        render: PrivateRoute,
        props: {
            path: AreasModule.AREA_DETAILS,
            component: AreaDetailsPageLoading,
            hasAccess: () => AreasPermissions.Admin.canRead,
        },
    });

    public static areaDetailsRoute = (areaId: string): string => {
        return `${AreasModule.AREA_DETAILS}`.replace(':id', areaId);
    };

    public static getAreasRoutes = (): Array<RouteItem> => {
        return [
            AreasModule.getAreaListRoute(),
            AreasModule.getAreaCreateRoute(),
            AreasModule.getAreaDetailsRoute(),
        ];
    };

    public static preloadAreas = () => {
        AreaListPageLoading.preload();
        AreaCreatePageLoading.preload();
        AreaDetailsPageLoading.preload();
    };

    public static getAreasModuleNavbar = (theme: IdelinkModuleTheme): NavbarModuleItem => {
        return {
            icon: theme.navbarIcon,
            label: <FormattedMessage id="navbar.areas" />,
            route: AreasModule.AREA_LIST,
            onMouseOver: () => AreasModule.preloadAreas(),
            disabled: !AreasPermissions.Admin.canRead,
            hide: PermissionsActions.shouldHideAdminSection(),
        };
    };
}
